import { render, staticRenderFns } from "./Erp6InventoryInEdit.vue?vue&type=template&id=587012a0&scoped=true&"
import script from "./Erp6InventoryInEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6InventoryInEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6InventoryInEdit.vue?vue&type=style&index=0&id=587012a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587012a0",
  null
  
)

export default component.exports